<template>
  <div class="list-nav-wrapper">
    <div class="list-nav-left">{{ isPathSubAccount ? '子账号管理' : '作品列表' }}</div>
    <div class="list-nav-right">
      <div v-if="!isPathSubAccount" class="list-nav-right-select">
        切换作品列表：
        <el-select size="mini" v-model="selectValue" placeholder="请选择" @change="changeAccount">
          <el-option :label="'我发布的作品'" :value="''"></el-option>
          <el-option v-for="(item, index) in selectOptions" :key="index" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
      <div v-if="!isSubAccount" class="list-nav-right-button" @click="toGo">
        <img v-if="!isPathSubAccount" src="@imgs/button_sub_account.png" />
        <div v-else><i class="el-icon el-icon-back"></i>返回作品列表</div>
      </div>
    </div>
  </div>
</template>
<script>
import compareVipRight from '@components/common/compareVipRight.js'
import subAccountApi from '@api/subAccount.js'
import { mapState } from 'vuex'

export default {
  name: 'listNav',
  mixins: [compareVipRight],
  data() {
    return {
      selectValue: '切换作品列表',
      selectOptions: []
    }
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    isPathSubAccount() {
      return this.$route.path === '/subAccount'
    },
    isSubAccount() {
      return this.$store.state.common.isSubAccount == 1
    }
  },
  methods: {
    toGo() {
      if (this.isPathSubAccount) {
        this.$router.push('/list')
      } else {
        this.$store.commit('manage/UPDATE_SUB_ACCOUNT_SIDEBAR_INFO', {
          index: 0,
          component: this.tabsComponent
        })
        this.$router.push('/subAccount')
      }
    },
    getAccountList() {
      const userName = localStorage.getItem('username')
      let param = {
        userName: userName
      }
      subAccountApi.getMainChildAccountList(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.selectOptions = res.data.data.filter((item) => {
            return item !== userName
          })
        }
      })
    },
    changeAccount() {
      this.$store.commit('manage/UPDATE_BOOKS_CURRENT_ACCOUNT', this.selectValue)
    }
  },
  mounted() {
    this.selectValue = this.booksCurrentSubAccount
    // this.$store.dispatch('manage/getSpace')
    // this.getVipInfo()
    this.getAccountList()
  }
}
</script>
<style lang="scss" scoped>
.list-nav-wrapper {
  height: 30px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .list-nav-left {
    font-size: 18px;
    font-weight: 600;
    color: #515151;
  }
  .list-nav-right {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    .list-nav-right-select {
      margin-right: 28px;
    }
    .list-nav-right-button {
      // margin-right: 20px;
      cursor: pointer;
      color: #df5813;
      line-height: 100%;
      height: 100%;
      .el-icon {
        margin-right: 3px;
      }
    }
  }
}
</style>
